import React from 'react'
import PropTypes from 'prop-types'
import { getApiBase } from '../../config'
import './ViolationItem.css'

const ViolationItem = ({ violation, onAddOrganization }) => {
	return (
		<div className="violation-item">
			<div className="violation-item-row">
				<div className="violation-item-field">
					<span className="violation-item-label">Case ID:</span>
					<span className="violation-item-value">{violation.caseId}</span>
				</div>
				<div className="violation-item-field">
					<span className="violation-item-label">URL:</span>
					<a
						href={violation.urlRaw || violation.url}
						target="_blank"
						rel="noopener noreferrer"
						className="violation-item-link"
					>
						{violation.urlRaw || violation.url}
					</a>
				</div>
				<div className="violation-item-field">
					<a
						href={`${getApiBase()}/violations/screenshot/600/${violation.violationId}`}
						target="_blank"
						rel="noopener noreferrer"
						className="violation-item-screenshot"
					>
						View Screenshot
					</a>
				</div>
				{onAddOrganization && (
					<button
						className="violation-item-add-org-button"
						onClick={() => onAddOrganization(violation)}
						title="Create new organization from this violation's URL"
					>
						+ Add Org
					</button>
				)}
			</div>
		</div>
	)
}

ViolationItem.propTypes = {
	violation: PropTypes.object.isRequired,
	onAddOrganization: PropTypes.func,
}

export default ViolationItem
